var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 64 64",
    id: "tiktok",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#aae1f9",
    d: "M35 4h8c.046 0 .092.003.136.009.484.04.874.427.91.919.534 5.554 5.672 12.315 11.055 13.002a1 1 0 0 1 .899.995c0 1.872 0 6.097-.004 8.05a.999.999 0 0 1-1.043.995c-4.008-.234-7.762-1.794-10.953-4.219V41c0 9.383-7.617 17-17 17s-17-7.617-17-17 7.617-17 17-17a1 1 0 0 1 1 1v8a1 1 0 0 1-1 .999V34c-3.863 0-7 3.137-7 7s3.137 7 7 7 7-3.137 7-7V5a1 1 0 0 1 1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd636e",
    d: "M37 6h8c.046 0 .092.003.136.009.484.04.874.427.91.919.534 5.554 5.672 12.315 11.055 13.002a1 1 0 0 1 .899.995c0 1.872 0 6.097-.004 8.05a.999.999 0 0 1-1.043.995c-4.008-.234-7.762-1.794-10.953-4.219V43c0 9.383-7.617 17-17 17s-17-7.617-17-17 7.617-17 17-17a1 1 0 0 1 1 1v8a1 1 0 0 1-1 .999V36c-3.863 0-7 3.137-7 7s3.137 7 7 7 7-3.137 7-7V7a1 1 0 0 1 1-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f6f9",
    d: "M44.202 6c.662 3.41 2.884 7.089 5.722 9.458 1.719 2.035 3.85 3.628 6.076 4.248 0 2.087-.001 5.554-.004 7.269a.999.999 0 0 1-1.043.995c-4.008-.234-7.762-1.794-10.953-4.219V41c0 9.383-7.617 17-17 17a16.928 16.928 0 0 1-10.977-4.023A16.928 16.928 0 0 1 12 43c0-9.047 7.082-16.452 16-16.971V33a1 1 0 0 1-1 .999V34c-3.863 0-7 3.137-7 7a6.994 6.994 0 0 0 3.153 5.847A6.994 6.994 0 0 0 29 50c3.863 0 7-3.137 7-7V7a1 1 0 0 1 1-1h7.202Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.47a3712fcebcee39f90e31ec14a0b681.svg";
export { ForwardRef as ReactComponent };